var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-col', [_c('h5', [_vm._v(_vm._s(_vm.$t('Wireless security')))]), _c('v-text-field', {
    attrs: {
      "label": "PSK-password",
      "dense": "",
      "outlined": "",
      "append-icon": _vm.show ? 'mdi-eye' : 'mdi-eye-off',
      "counter": "",
      "hint": _vm.$t('At least 8 characters'),
      "rules": _vm.rules,
      "type": _vm.show ? 'text' : 'password'
    },
    on: {
      "click:append": function ($event) {
        _vm.show = !_vm.show;
      },
      "input": function ($event) {
        return _vm.update('type', $event.target.value);
      }
    },
    model: {
      value: _vm.value.psk,
      callback: function ($$v) {
        _vm.$set(_vm.value, "psk", $$v);
      },
      expression: "value.psk"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }